import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_HOSPITAL_EMROK_MONTHLY_SALES_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const EmrokMonthlySales = lazy(() =>
  import('../../../screens/HospitalEmrokMonthlySalesReport')
    .then(module => ({default: module.HospitalEmrokMonthlySalesReport})));

const HospitalEmrokMonthlySalesReportNavigation = [
  {
    path: ROUTE_HOSPITAL_EMROK_MONTHLY_SALES_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EmrokMonthlySales />
      </Suspense>
    ),
  },
];
export default HospitalEmrokMonthlySalesReportNavigation;
